<article class="result-detail-layout2">

  <!-- TODO: 로딩 중이라는 표현 추가해야함! -->

  <ng-container *ngIf="dialect">

    <div class="detail-info-box">

      <div class="info-contents-box">

        <div class="info-item-box" *ngIf="dialect.standard || dialect.standardWord">
          <div class="subject-box align-end">표준말</div>
          <div class="con-box">
            <div class="keyword-txt-box"
                 *ngIf="dialect.standard">
              <app-word-disp [word]="dialect.standard"
                             [linkPopup]="true"
                             class="smaller tooltip-target"></app-word-disp>

              <div *ngIf="dialect.standard?.wordVoice"
                   class="detail-option-box">
                <!-- 소리 재생 버튼 -->
                <app-dialect-word-play-btn [word]="dialect.standard"></app-dialect-word-play-btn>
              </div>
            </div>
            <div *ngIf="!dialect.standard && dialect.standardWord"
                 class="standard-word">{{ dialect.standardWord }}</div>


          </div>
        </div>

        <div class="info-item-box">
          <div class="subject-box"><span class="subject-txt">뜻</span></div>
          <div class="con-box">

            <ng-container *ngFor="let meaning3 of dialect.meaning3; let idx = index">
              <div class="meaning-box" *ngIf="dialect.GetMeaning3Nth(idx)">
                <div class="txt-list-box">
                  <div class="meaning-num"
                       *ngIf="idx !== 0">{{ idx }}.</div>

                  <app-link-content class="txt-box"
                                    [content]="dialect.GetMeaning3Nth(idx) | slash2br | resize"></app-link-content>
                </div>

                <div *ngIf="dialect.GetExample3Nth(idx)"
                     class="txt-list-box">
                  <div class="example-box">
                    <span class="example-txt">예</span>
                  </div>
                  <app-link-content class="txt-box"
                                    [content]="dialect.GetExample3Nth(idx) | slash2br | resize"></app-link-content>
                </div>

                <div *ngIf="dialect.GetExplanation3Nth(idx)"
                     class="txt-list-box">
                  <div class="example-box">
                    <span class="example-txt">풀이</span>
                  </div>
                  <app-link-content class="txt-box"
                                    [content]="dialect.GetExplanation3Nth(idx) | slash2br | resize"></app-link-content>
                </div>
              </div>
            </ng-container>

          </div>
        </div>

      </div>







    </div>


    <div *ngIf="dialect.wordMore"
         class="detail-similar">

      <article class="detail-tit-layout">
        <div class="tit-txt-box"><b>비슷한 말</b></div>
      </article>

      <div class="similar-list">

        <div *ngFor="let w of dialect.wordMore"
             class="similar-box">{{ w }}</div>

      </div>

    </div>






    <div class="detail-other-box"
         *ngIf="dialect.dialects?.length ?? 0 > 0">

      <app-dialect-map-btn [dialects]="dialect.allDialects"
                           [word]="dialect.standard ?? null"></app-dialect-map-btn>

      <div class="other-list">

        <app-dialect-item *ngFor="let other of dialect.dialects"
                          [dialect]="other"
                          [linkPopup]="true"
                          [showNavigationArrow]="true"></app-dialect-item>

      </div>
    </div>
  </ng-container>
</article>
